import React, { useEffect, useState, useContext } from "react";
import "./ChooseCategory.scss";
import { getDisciplinesList, getStages, getProjectSheetPath, getLastUpdateTime } from "../../../utils/builder/IModelsTree";
import UniversalButton from "../../uiComponents/UniversalButton";
import { ModalContext } from "../../ModalContext";
import { format } from "date-fns";
import Loader from "components/uiComponents/Loader";
import { getProjectIdAction } from "store/actions/currentProject";

const ChooseCategory = ({ loadModel }) => {
    const [stages, setStages] = useState([]);
    const [disciplines, setDisciplines] = useState([]);
    const [categories, setCategories] = useState(null);
    const [lastUpdate, setLastUpdate] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    
    const projectId = getProjectIdAction()
    
    useEffect(() => {
        (
            async () => {
                setStages(getStages());
                setDisciplines(getDisciplinesList());
                const data = await getLastUpdateTime(projectId);
                if (data !== -1) {
                    setLastUpdate(data)
                }
                setIsLoading(false)
            }
        )()
    }, [projectId])

    const { handleModal } = useContext(ModalContext);

    const handleCloseModal = () => {
        handleModal(null, true);
    };

    const openSheet = async () => {
        var path = await getProjectSheetPath(projectId);
        var date = await getLastUpdateTime(projectId);
        setLastUpdate(date)
        window.open(path, '_blank');
    }

    const handleClickCheck = () => {
        const JsonCategories = JSON.stringify(categories);
        localStorage.setItem('categories', JsonCategories)
        loadModel();
        handleCloseModal();
    };

    const chooseCategory = (discipline, stage) => {
        setCategories({ discipline, stage });
    };

    const renderLastUpdate = () => {
        if (!lastUpdate) {
            return
        }

        return (
            <p className="discipline-btn_date">
                Update at {format(new Date(lastUpdate * 1000), 'MM.dd.yyyy')}
            </p>
        )
    }

    return (
        <form className="categories">
            <div className="categories__header">סוג הבדיקה</div>
            <table>
                <tbody>
                    <tr className="stages">
                        {
                           stages?.length > 0 &&  stages.map((stage) => {
                                return (
                                    <td key={stage} className="stage">{stage}</td>
                                )
                            })
                        }
                        <td className="stage">דיסציפלינה</td>
                    </tr>
                    {
                       disciplines?.length > 0 && disciplines.map((discipline) => {
                            return (
                                <tr key={discipline} className="disciplineWrapper">
                                    {
                                        stages.map((stage) => {
                                            return (
                                                <td className="inputWrapper" key={discipline + stage}>
                                                    <input className="disciplineInput" id={discipline + stage} type="radio" name="radio" onClick={() => chooseCategory(discipline, stage)} />
                                                    <label htmlFor={discipline + stage} className="checkmark"></label>
                                                </td>
                                            )
                                        })
                                    }
                                    <td key={discipline} className="discipline">{discipline}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
            <div className="modal_btns modal_btns--sbtw">
                <div className="discipline-btn_wrapper">
                    <UniversalButton
                        type="button"
                        label="Discipline Table"
                        size="lg"
                        labelColor="white"
                        labelHoverColor="white"
                        backgroundColor="orange"
                        backgroundHoverColor="orange-light"
                        isDisabled={!projectId}
                        onClick={openSheet}
                    />
                    {!isLoading ? renderLastUpdate()
                                : <Loader/>
                    }
                </div>
                <div className="modal_btns_wrapper">
                    <UniversalButton
                        type="button"
                        label="Cancel"
                        size="lg"
                        labelColor="blue"
                        labelHoverColor="blue"
                        backgroundColor="white"
                        backgroundHoverColor="blue-light"
                        onClick={handleCloseModal}
                    />
                    <UniversalButton
                        type="button"
                        label="Check"
                        size="lg"
                        labelColor="white"
                        labelHoverColor="white"
                        backgroundColor="orange"
                        backgroundHoverColor="orange-light"
                        isDisabled={!categories}
                        onClick={handleClickCheck}
                    />
                </div>
            </div>
        </form>
    );
};

export default ChooseCategory;